import { __decorate } from "tslib";
import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ActionButton from '@/components/action_button/Index.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import PsgcRegions from '@/components/v2/PsgcRegions';
import PsgcCities from '@/components/v2/PsgcCities';
import PsgcBarangays from '@/components/v2/PsgcBarangays';
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators';
import ShippingFormThirdPartyActivate from '@/plugins/graphql/mutations/v2/shipping-method-third-party-activate.gql';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import CreditTopUpMixin from '@/helpers/vue_mixins/v2/CreditTopUpMixin';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import ShippingMethods from '@/plugins/graphql/queries/v2/shipping-methods.gql';
import AppBasicDetails from '@/components/v2/AppBasicDetails';
import { PsgcRegionModel } from '@/helpers/entities/models/PsgcRegionModel';
import PickupPointUpdate from '@/plugins/graphql/mutations/v2/pickup-point-update.gql';
import PickupPointFragment from '@/plugins/graphql/fragments/v2/pickup-point.gql';
import PhoneInput from '@/components/v2/PhoneInput.vue';
import LocationGeocoding from '@/plugins/graphql/queries/v2/location-geocoding.gql';
import { GRAB_EXPRESS_ALLOWED_REGIONS, GRAB_EXPRESS_RIZAL_CITIES, GRAB_EXPRESS_CAVITE_CITIES, GRAB_EXPRESS_CEBU_CITIES, LALAMOVE_ALLOWED_REGIONS, LALAMOVE_CEBU_CITIES, LALAMOVE_PAMAPANGA_CITIES, DEFAULT_LAT, DEFAULT_LNG, } from '@/helpers/constants/app';
import { PANDAGO_ALLOWED_REGIONS, PANDAGO_ALLOWED_CITIES, } from '@/helpers/constants/PandagoDeliveryAreas';
import { trim } from 'lodash';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import ShippingMethodUpdate from '@/plugins/graphql/mutations/v2/shipping-method-update.gql';
import SavedThirdPartyDetails from '@/plugins/graphql/queries/v2/saved-thirdparty-details.gql';
import ShippingFragment from '@/plugins/graphql/fragments/v2/shipping-method.gql';
import { ShippingMethodThirdPartyProvider } from '@/helpers/entities/enums/v2/ShippingMethodThirdPartyProvider';
import CreditsWidget from '@/plugins/graphql/queries/v2/grab-express-credits.gql';
import GoogleMaps from '@/components/v2/GoogleMaps.vue';
import { selectOptionBuilder } from '@/helpers/select_option_builder';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import BaseTextArea from '@/components/v2/BaseTextArea';
import { JNTEXPRESS_PROHIBITED_CITIES } from '@/helpers/constants/JntExpressUnserviceableAreas';
import { ncrBarangays } from '@/helpers/constants/jnt/NcrBarangays';
import { carBarangays } from '@/helpers/constants/jnt/CarBarangays';
import { armmBarangays } from '@/helpers/constants/jnt/ArmmBarangays';
import { region1Barangays } from '@/helpers/constants/jnt/Region1Barangays';
import { region2Barangays } from '@/helpers/constants/jnt/Region2Barangays';
import { region3Barangays } from '@/helpers/constants/jnt/Region3Barangays';
import { region4aBarangays } from '@/helpers/constants/jnt/Region4aBarangays';
import { region4bBarangays } from '@/helpers/constants/jnt/Region4bBarangays';
import { region5Barangays } from '@/helpers/constants/jnt/Region5Barangays';
import { region6Barangays } from '@/helpers/constants/jnt/Region6Barangays';
import { region7Barangays } from '@/helpers/constants/jnt/Region7Barangays';
import { region8Barangays } from '@/helpers/constants/jnt/Region8Barangays';
import { region9Barangays } from '@/helpers/constants/jnt/Region9Barangays';
import { region10Barangays } from '@/helpers/constants/jnt/Region10Barangays';
import { region11Barangays } from '@/helpers/constants/jnt/Region11Barangays';
import { region12Barangays } from '@/helpers/constants/jnt/Region12Barangays';
import { region13Barangays } from '@/helpers/constants/jnt/Region13Barangays';
let ShippingFormThirdParty = class ShippingFormThirdParty extends Mixins(Mixins(AlertMixin, FormMixin, FormValidationsMixin, RouterParamsAppMixin, ViewportSizeMixin), CreditTopUpMixin, PaginatorMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.mutationRequestOnFlight = false;
        this.validPhone = false;
        this.credit = null;
        this.locationGeocoding = {};
        this.savedThirdPartyDetails = {};
        this.isDataLoaded = false;
        this.form = {
            region: this.ncr,
            city: null,
            street: null,
            contactPerson: null,
            contactNumber: null,
            description: '',
            country: 'ph',
            merchantCategory: null,
            shippingBuyout: false,
            shippingNonBuyout: false,
            remarks: null,
            lat: null,
            lng: null,
            barangay: null,
            building: null,
            floorNumber: null,
            unitNumber: null,
            pickUpTimeSlot: null,
        };
        this.ninjaVanPickUpTimeSlot = [
            { startAt: '9:00', endAt: '12:00' },
            { startAt: '9:00', endAt: '18:00' },
            { startAt: '9:00', endAt: '22:00' },
            { startAt: '12:00', endAt: '15:00' },
            { startAt: '15:00', endAt: '18:00' },
            { startAt: '18:00', endAt: '22:00' },
        ];
        this.toggle = false;
        this.selectedThirdParty = null;
    }
    get ninjaVanPickUpTimeSlotOption() {
        return this.ninjaVanPickUpTimeSlot.map((slot) => `${this.convertTo12HrFormat(slot.startAt)} to ${this.convertTo12HrFormat(slot.endAt)}`);
    }
    convertTo12HrFormat(time) {
        const time_split = time.split(':');
        let hour = time_split[0];
        const minute = time_split[1];
        let period = 'AM';
        if (hour >= 12) {
            period = 'PM';
            if (hour > 12) {
                hour -= 12;
            }
        }
        return `${hour}:${minute} ${period}`;
    }
    /**
     * Default Region Selection
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.3.0}
     *
     * @return {void}
     */
    get ncr() {
        return new PsgcRegionModel({
            name: 'NATIONAL CAPITAL REGION (NCR)',
            regionCode: '13',
            psgcCode: '',
        });
    }
    markLocation(markers) {
        this.form.lat = markers[0].lat.toString();
        this.form.lng = markers[0].lng.toString();
    }
    get mrSpeedyShipping() {
        if (this.selectedThirdParty) {
            return (this.selectedThirdParty.thirdPartyProvider === ShippingMethodThirdPartyProvider.MrSpeedy);
        }
        return false;
    }
    get grabExpressShipping() {
        if (this.selectedThirdParty) {
            return (this.selectedThirdParty.thirdPartyProvider === ShippingMethodThirdPartyProvider.GrabExpress);
        }
        return false;
    }
    get lalamoveShipping() {
        if (this.selectedThirdParty) {
            return (this.selectedThirdParty.thirdPartyProvider === ShippingMethodThirdPartyProvider.Lalamove);
        }
        return false;
    }
    get pandagoShipping() {
        if (this.selectedThirdParty) {
            return (this.selectedThirdParty.thirdPartyProvider === ShippingMethodThirdPartyProvider.PandaGo);
        }
        return false;
    }
    get ninjaVanShipping() {
        if (this.selectedThirdParty) {
            return (this.selectedThirdParty.thirdPartyProvider === ShippingMethodThirdPartyProvider.NinjaVan);
        }
        return false;
    }
    get isRequired() {
        return false;
    }
    get jntExpressShipping() {
        if (this.selectedThirdParty) {
            return (this.selectedThirdParty.thirdPartyProvider === ShippingMethodThirdPartyProvider.JntExpress);
        }
        return false;
    }
    shippingLabel() {
        if (this.mrSpeedyShipping) {
            return 'Mr Speedy Fee';
        }
        if (this.lalamoveShipping) {
            return 'Lalamove';
        }
        if (this.grabExpressShipping) {
            return 'Grab Express';
        }
        if (this.pandagoShipping) {
            return 'PandaGo';
        }
    }
    get activatedGrabExpressShipping() {
        if (this.selectedThirdParty) {
            return ((this.selectedThirdParty.thirdPartyProvider ===
                ShippingMethodThirdPartyProvider.GrabExpress ||
                this.selectedThirdParty.thirdPartyProvider ===
                    ShippingMethodThirdPartyProvider.Lalamove ||
                this.selectedThirdParty.thirdPartyProvider ===
                    ShippingMethodThirdPartyProvider.PandaGo) &&
                this.activatedPickUpPoints);
        }
        return false;
    }
    get activatedPickUpPoints() {
        if (this.selectedThirdParty && this.selectedThirdParty.pickupPoints) {
            return this.selectedThirdParty.pickupPoints.length > 0 || this.canActivateThirdPartyShipping;
        }
        return false;
    }
    get canActivateThirdPartyShipping() {
        if (this.credit && this.selectedThirdParty) {
            return ((this.selectedThirdParty.thirdPartyProvider ===
                ShippingMethodThirdPartyProvider.GrabExpress ||
                this.selectedThirdParty.thirdPartyProvider ===
                    ShippingMethodThirdPartyProvider.Lalamove ||
                this.selectedThirdParty.thirdPartyProvider ===
                    ShippingMethodThirdPartyProvider.PandaGo) &&
                this.credit.totalCredits >= 1000);
        }
        return false;
    }
    toggleForm(obj) {
        const vm = this;
        this.selectedThirdParty = obj;
        if (obj.uuid) {
            const pickupPoint = obj.pickupPoints ? obj.pickupPoints[0] : null;
            this.updateForm(pickupPoint, obj, true);
            this.form.description = obj.description || '';
        }
        else if (this.savedThirdPartyDetails && Object.keys(this.savedThirdPartyDetails).length > 0) {
            const details = this.savedThirdPartyDetails;
            const pickupPoint = details.pickupPoints.edges[0].node;
            const fillRegion = this.checkShippingRegionAvailability(pickupPoint.regionCode);
            this.updateForm(pickupPoint, details, fillRegion);
            if (!fillRegion) {
                this.resetFormLocations();
            }
            this.form.uuid = obj.uuid;
        }
        if (this.selectedThirdParty.name && !this.form.uuid) {
            this.form.barangay = null;
        }
        this.form.description = obj.description;
        this.form.pickUpTimeSlot = obj.pickUpTimeSlot;
        vm.$v.form.pickUpTimeSlot.$reset();
        this.toggle = !this.toggle;
        this.updateGMapsMarker();
    }
    checkShippingRegionAvailability(regionCode) {
        if (this.grabExpressShipping && GRAB_EXPRESS_ALLOWED_REGIONS.includes(regionCode)) {
            return true;
        }
        if (this.lalamoveShipping && LALAMOVE_ALLOWED_REGIONS.includes(regionCode)) {
            return true;
        }
        if (this.pandagoShipping && PANDAGO_ALLOWED_REGIONS.includes(regionCode)) {
            return true;
        }
        if (this.ninjaVanShipping) {
            return true;
        }
        if (this.jntExpressShipping) {
            return true;
        }
        return false;
    }
    updateForm(pickupPoint, details, fillRegion) {
        if (pickupPoint) {
            const { uuid, region, regionCode, city, country, street, contactName, contactNumber, merchantCategory, shippingBuyout, shippingNonBuyout, remarks, lat, lng, barangay, building, floorNumber, unitNumber, } = pickupPoint;
            this.form = {
                uuid,
                region: fillRegion ? new PsgcRegionModel({ name: region, regionCode, psgcCode: '' }) : null,
                city: fillRegion ? city : null,
                country,
                street: fillRegion ? street : null,
                contactPerson: contactName,
                contactNumber,
                merchantCategory,
                shippingBuyout,
                shippingNonBuyout,
                remarks: fillRegion ? remarks : null,
                lat: fillRegion ? lat.toString() || null : null,
                lng: fillRegion ? lng.toString() || null : null,
                barangay: fillRegion ? barangay : null,
                building: fillRegion ? building : null,
                floorNumber: fillRegion ? floorNumber : null,
                unitNumber: fillRegion ? unitNumber : null,
                pickUpTimeSlot: details.pickUpTimeSlot,
                description: details.description || '',
            };
        }
    }
    /**
     * Update Google Maps Marker
     * @author Angelo David <adavid@gorated.ph>
     * @since Version {0.63.3}
     */
    updateGMapsMarker() {
        const gmapsElement = this.$refs.gmaps;
        if (!gmapsElement) {
            return;
        }
        const locations = gmapsElement.markers;
        locations.pop();
        if (this.activatedGrabExpressShipping) {
            locations.push({ lat: this.form.lat, lng: this.form.lng });
        }
        else {
            locations.push({ lat: DEFAULT_LAT, lng: DEFAULT_LNG });
        }
    }
    onCancel() {
        const shipping = this.selectedThirdParty;
        if (shipping && shipping.uuid === '') {
            this.$emit('cancel', shipping);
        }
        else {
            this.$emit('cancelPersistent');
        }
        this.closeForm();
    }
    closeForm() {
        this.toggle = !this.toggle;
    }
    onRegionSelection(region) {
        this.form.region = region;
        this.resetFormLocations();
    }
    resetFormLocations() {
        const vm = this;
        // Define the fields to be reset
        const fields = [
            'city',
            'street',
            'remarks',
            'lat',
            'lng',
            'barangay',
            'floorNumber',
            'unitNumber',
        ];
        // Reset the form fields to null
        fields.forEach((field) => {
            this.form[field] = null;
        });
        // Define the fields to reset the validation states
        const validation_fields = ['city', 'street', 'barangay', 'lat', 'lng', 'region'];
        // Reset validation states
        validation_fields.forEach((field) => {
            vm.$v.form[field].$reset();
        });
    }
    onCitySelection(city) {
        this.form.city = city;
    }
    filterAllowedRegions(regions) {
        return regions?.filter((region) => {
            if (this.grabExpressShipping) {
                return GRAB_EXPRESS_ALLOWED_REGIONS.includes(region.regionCode);
            }
            if (this.lalamoveShipping) {
                return LALAMOVE_ALLOWED_REGIONS.includes(region.regionCode);
            }
            if (this.pandagoShipping) {
                return PANDAGO_ALLOWED_REGIONS.includes(region.regionCode);
            }
            if (this.ninjaVanShipping) {
                return region;
            }
            if (this.jntExpressShipping) {
                return region;
            }
        });
    }
    get merchantCategories() {
        return [
            selectOptionBuilder('art', 'Art & Design'),
            selectOptionBuilder('auto', 'Auto & Vehicles'),
            selectOptionBuilder('beauty', 'Beauty'),
            selectOptionBuilder('books', 'Books & Refence'),
            selectOptionBuilder('business', 'Business'),
            selectOptionBuilder('comics', 'Comics'),
            selectOptionBuilder('communication', 'Communications'),
            selectOptionBuilder('dating', 'Dating'),
            selectOptionBuilder('education', 'Education'),
            selectOptionBuilder('entertainment', 'Entertainment'),
            selectOptionBuilder('events', 'Events'),
            selectOptionBuilder('finance', 'Finance'),
            selectOptionBuilder('food', 'Food & Beverage'),
            selectOptionBuilder('games', 'Games'),
            selectOptionBuilder('health', 'Health & Fitness'),
            selectOptionBuilder('house', 'House & Home'),
            selectOptionBuilder('lifestyle', 'Lifestyle'),
            selectOptionBuilder('maps', 'Maps & Navigation'),
            selectOptionBuilder('medical', 'Medical'),
            selectOptionBuilder('music', 'Music & Audio'),
            selectOptionBuilder('news', 'News & Magazines'),
            selectOptionBuilder('parenting', 'Parenting'),
            selectOptionBuilder('personalization', 'Personalization'),
            selectOptionBuilder('photography', 'Photography'),
            selectOptionBuilder('productivity', 'Productivity'),
            selectOptionBuilder('shopping', 'Shopping'),
            selectOptionBuilder('social', 'Social'),
            selectOptionBuilder('sports', 'Sports'),
            selectOptionBuilder('tools', 'Tools'),
            selectOptionBuilder('travel', 'Travel & Local'),
            selectOptionBuilder('video_players', 'Video Players & Editors'),
            selectOptionBuilder('weather', 'Weather'),
            selectOptionBuilder('others', 'Others'),
        ];
    }
    filterAllowedCities(cities, regionCode) {
        if (regionCode !== '13') {
            if (this.grabExpressShipping) {
                const supportedCities = [
                    ...GRAB_EXPRESS_RIZAL_CITIES,
                    ...GRAB_EXPRESS_CAVITE_CITIES,
                    ...GRAB_EXPRESS_CEBU_CITIES,
                ];
                return cities?.filter((city) => {
                    return supportedCities.includes(city.cityMunicipalityCode);
                });
            }
            if (this.lalamoveShipping) {
                const supportedCities = [...LALAMOVE_CEBU_CITIES, ...LALAMOVE_PAMAPANGA_CITIES];
                return cities?.filter((city) => {
                    return supportedCities.includes(city.cityMunicipalityCode);
                });
            }
            if (this.pandagoShipping) {
                const supportedCities = [...PANDAGO_ALLOWED_CITIES];
                return cities?.filter((city) => {
                    return supportedCities.includes(city.cityMunicipalityCode);
                });
            }
            if (this.ninjaVanShipping) {
                return cities;
            }
            if (this.jntExpressShipping) {
                // Exclude specific cities for JnT Express Shipping
                const unserviceableCities = [...JNTEXPRESS_PROHIBITED_CITIES];
                return cities?.filter((city) => {
                    return !unserviceableCities.includes(city.cityMunicipalityCode);
                });
            }
        }
        return cities;
    }
    filterAllowedBarangays(barangays) {
        return barangays;
    }
    /**
     * Filter Grab Express Coverage Regions
     * @author Angelo David <adavid@gorated.ph>
     * @since Version {0.55.1}
     */
    filterGrabExpressAllowedRegions(regions) {
        return regions?.filter((region) => {
            return GRAB_EXPRESS_ALLOWED_REGIONS.includes(region.regionCode);
        });
    }
    /**
     * Filter Grab Express Coverage Cities
     * @author Angelo David <adavid@gorated.ph>
     * @since Version {0.55.1}
     */
    filterGrabExpressAllowedCities(cities, regionCode) {
        if (regionCode !== '13') {
            const supportedCities = [
                ...GRAB_EXPRESS_RIZAL_CITIES,
                ...GRAB_EXPRESS_CAVITE_CITIES,
                ...GRAB_EXPRESS_CEBU_CITIES,
            ];
            return cities?.filter((city) => {
                return supportedCities.includes(city.cityMunicipalityCode);
            });
        }
        return cities;
    }
    async activate() {
        const vm = this;
        const appUuid = this.appUUID;
        const { region, city, street, contactPerson, contactNumber, country, merchantCategory, shippingBuyout, shippingNonBuyout, description, remarks, lat, lng, barangay, building, floorNumber, unitNumber, pickUpTimeSlot, } = this.form;
        if (this.selectedThirdParty) {
            const { name, shippingType, thirdPartyProvider, customerInitiated } = this.selectedThirdParty;
            return this.$apollo.mutate({
                mutation: ShippingFormThirdPartyActivate,
                variables: {
                    input: {
                        appUuid,
                        name,
                        description,
                        shippingType,
                        customerInitiated,
                        thirdPartyProvider,
                        pickUpTimeSlot,
                        pickupDetails: {
                            region: region.name,
                            regionCode: region.regionCode,
                            city,
                            street,
                            contactName: contactPerson,
                            contactNumber: this.mrSpeedyShipping
                                ? trim(contactNumber || '')
                                : trim(contactNumber || '').replace('+', ''),
                            country,
                            merchantCategory,
                            shippingBuyout,
                            shippingNonBuyout,
                            remarks,
                            lat: parseFloat(lat),
                            lng: parseFloat(lng),
                            barangay,
                            building,
                            floorNumber,
                            unitNumber,
                        },
                    },
                },
                update(cache, { data }) {
                    const { shippingMethod } = data.shippingMethodThirdPartyActivate;
                    const queryOptions = {
                        query: ShippingMethods,
                        variables: {
                            appUuid: vm.appUUID,
                        },
                    };
                    const { fetchAllShippingMethod } = cache.readQuery(queryOptions);
                    const cachedShippingMethods = {
                        ...fetchAllShippingMethod,
                    };
                    cachedShippingMethods.edges.unshift({
                        node: shippingMethod,
                        __typename: 'ShippingMethodEdges',
                    });
                    cache.writeQuery({
                        ...queryOptions,
                        data: {
                            fetchAllShippingMethod: cachedShippingMethods,
                        },
                    });
                },
                refetchQueries: [
                    {
                        query: ShippingMethods,
                        variables: {
                            appUuid: vm.appUUID,
                            first: this.perPage,
                            after: this.startCursor,
                        },
                    },
                ],
            });
        }
    }
    async updateShippingDescription() {
        if (this.selectedThirdParty) {
            return this.$apollo.mutate({
                mutation: ShippingMethodUpdate,
                variables: {
                    input: {
                        description: this.form.description,
                        name: this.selectedThirdParty.name,
                        shippingMethodUuid: this.selectedThirdParty.uuid,
                        customerInitiated: false,
                        pickUpTimeSlot: this.form.pickUpTimeSlot,
                    },
                },
                update(cache, { data }) {
                    const { shippingMethodUpdate } = data;
                    const shipping = shippingMethodUpdate;
                    cache.writeFragment({
                        id: shipping.shippingMethod?.uuid,
                        fragment: ShippingFragment,
                        fragmentName: 'ShippingMethod',
                        data: shipping,
                    });
                },
            });
        }
    }
    async update() {
        const { region, city, street, contactPerson, contactNumber, country, merchantCategory, shippingBuyout, shippingNonBuyout, uuid, remarks, lat, lng, barangay, building, floorNumber, unitNumber, } = this.form;
        return this.$apollo.mutate({
            mutation: PickupPointUpdate,
            variables: {
                input: {
                    pickupPointUuid: uuid,
                    region: region.name,
                    regionCode: region.regionCode,
                    city,
                    street,
                    contactName: contactPerson,
                    contactNumber: this.mrSpeedyShipping
                        ? trim(contactNumber || '')
                        : trim(contactNumber || '').replace('+', ''),
                    country,
                    merchantCategory,
                    shippingBuyout,
                    shippingNonBuyout,
                    remarks,
                    lat: parseFloat(lat),
                    lng: parseFloat(lng),
                    barangay,
                    building,
                    floorNumber,
                    unitNumber,
                },
            },
            update(cache, { data }) {
                const { pickupPoint } = data.pickupPointUpdate;
                cache.writeFragment({
                    id: pickupPoint.uuid,
                    fragment: PickupPointFragment,
                    fragmentName: 'PickupPoint',
                    data: pickupPoint,
                });
            },
        });
    }
    async onSubmit() {
        this.$v.$touch();
        const shippingName = this.header.replace(/\s*(Form|Activation)\s*/gi, '');
        const mutation = () => {
            if (this.form.uuid) {
                this.shippingManagerAction('SUBMIT EDIT', shippingName);
                return this.update() && this.updateShippingDescription();
            }
            this.shippingManagerAction('SUBMIT CREATE', shippingName);
            return this.activate();
        };
        if (!this.$v.$invalid) {
            this.mutationRequestOnFlight = true;
            await mutation()
                .then(({ data }) => {
                const action = this.form.uuid ? 'Updated' : 'Activated';
                this.successNotification(`Shipping Successfully ${action}`);
                if (!this.form.uuid && !data.shippingMethodThirdPartyActivate.hasEnabledShipping) {
                    this.$store.commit('setTodoSuccessMessage', "You've unlocked more shipping flexibility, which is key to customer satisfaction.");
                }
            })
                .catch((error) => {
                this.errorNotification(error.message);
            })
                .finally(() => {
                this.closeForm();
                this.mutationRequestOnFlight = false;
                this.refetchshipping();
                this.$apollo.queries.savedThirdPartyDetails.refetch();
            });
        }
    }
    get initialLat() {
        if (this.activatedGrabExpressShipping) {
            return this.form.lat;
        }
        if (this.grabExpressShipping) {
            return this.form.lat;
        }
        if (this.ninjaVanShipping) {
            return this.form.lat;
        }
        if (this.jntExpressShipping) {
            return this.form.lat;
        }
        return DEFAULT_LAT;
    }
    get initialLng() {
        if (this.activatedGrabExpressShipping) {
            return this.form.lng;
        }
        if (this.grabExpressShipping) {
            return this.form.lng;
        }
        if (this.ninjaVanShipping) {
            return this.form.lng;
        }
        if (this.jntExpressShipping) {
            return this.form.lng;
        }
        return DEFAULT_LNG;
    }
    get formattedAddress() {
        return `${this.form.street}, ${this.form.barangay}, ${this.form.city}, ${this.form.region?.name}`;
    }
    updateLatAndLang() {
        this.$apollo.queries.locationGeocoding.refetch();
        this.changeMapPin(this.locationGeocoding);
    }
    changeMapPin(response) {
        this.form.lat = response.lat.toString();
        this.form.lng = response.lng.toString();
        const locations = this.$refs.gmaps.markers;
        locations.pop();
        locations.push({ lat: this.form.lat, lng: this.form.lng });
    }
    onDataLoaded() {
        if (this.hasAllData()) {
            this.isDataLoaded = true;
            this.checkAndUpdateLatLng();
        }
    }
    hasAllData() {
        return this.savedThirdPartyDetails;
    }
    checkAndUpdateLatLng() {
        if (this.isDataLoaded &&
            this.form.lat &&
            this.form.lng &&
            this.form.lat !== '0' &&
            this.form.lng !== '0') {
            this.updateLatAndLang();
        }
    }
    get filteredBarangays() {
        if (!this.form.city || !this.form.region || !this.form.region.name) {
            return [];
        }
        const cityName = this.form.city
            .replace(/Ñ/g, 'N')
            .replace(/ñ/g, 'n')
            .replace(/\s?city$/i, '')
            .replace(/\s+/g, '-')
            .toUpperCase();
        const regionBarangayData = {
            'NATIONAL CAPITAL REGION (NCR)': ncrBarangays,
            'CORDILLERA ADMINISTRATIVE REGION (CAR)': carBarangays,
            'AUTONOMOUS REGION IN MUSLIM MINDANAO (ARMM)': armmBarangays,
            'REGION I (ILOCOS REGION)': region1Barangays,
            'REGION II (CAGAYAN VALLEY)': region2Barangays,
            'REGION III (CENTRAL LUZON)': region3Barangays,
            'REGION IV-A (CALABARZON)': region4aBarangays,
            'REGION IV-B (MIMAROPA)': region4bBarangays,
            'REGION V (BICOL REGION)': region5Barangays,
            'REGION VI (WESTERN VISAYAS)': region6Barangays,
            'REGION VII (CENTRAL VISAYAS)': region7Barangays,
            'REGION VIII (EASTERN VISAYAS)': region8Barangays,
            'REGION IX (ZAMBOANGA PENINSULA)': region9Barangays,
            'REGION X (NORTHERN MINDANAO)': region10Barangays,
            'REGION XI (DAVAO REGION)': region11Barangays,
            'REGION XII (SOCCSKSARGEN)': region12Barangays,
            'REGION XIII (CARAGA)': region13Barangays,
        };
        const regionName = this.form.region.name.toUpperCase();
        const barangayData = regionBarangayData[regionName];
        const cityData = barangayData.filter((city) => city.CITY.toUpperCase() === cityName);
        // return cityData.map((item) => item.BARANGAY);
        return cityData
            .map((item) => item.BARANGAY)
            .sort((a, b) => {
            const extractNumberAndSuffix = (barangay) => {
                const match = barangay.match(/(\d+)([-~]?[A-Z]?)$/i);
                if (!match)
                    return { number: Number.MAX_SAFE_INTEGER, suffix: '' };
                return { number: parseInt(match[1], 10), suffix: match[2] || '' };
            };
            const barangayA = extractNumberAndSuffix(a);
            const barangayB = extractNumberAndSuffix(b);
            // Compare numeric portion first
            if (barangayA.number !== barangayB.number) {
                return barangayA.number - barangayB.number;
            }
            // Compare suffix lexicographically
            return barangayA.suffix.localeCompare(barangayB.suffix);
        });
    }
    onCityChanged(newCity, oldCity) {
        this.form.barangay = this.filteredBarangays;
    }
    filterJntAllowedBarangays() {
        return this.filteredBarangays;
    }
};
__decorate([
    Prop({ type: String, required: true })
], ShippingFormThirdParty.prototype, "header", void 0);
__decorate([
    Prop({ type: Function, required: true })
], ShippingFormThirdParty.prototype, "refetchshipping", void 0);
__decorate([
    Watch('selectedCity')
], ShippingFormThirdParty.prototype, "onCityChanged", null);
ShippingFormThirdParty = __decorate([
    Component({
        apollo: {
            credit: {
                query: CreditsWidget,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    return data.grabExpressCredits;
                },
                fetchPolicy: 'cache-and-network',
            },
            locationGeocoding: {
                query: LocationGeocoding,
                variables() {
                    return {
                        address: this.formattedAddress,
                    };
                },
            },
            savedThirdPartyDetails: {
                query: SavedThirdPartyDetails,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    return data.savedThirdPartyDetails;
                },
                result({ data }) {
                    this.onDataLoaded();
                },
            },
        },
        components: {
            ActionButton,
            BaseTextField,
            BaseTextArea,
            FormHeader,
            PsgcCities,
            PsgcRegions,
            PsgcBarangays,
            PhoneInput,
            AppBasicDetails,
            GoogleMaps,
        },
        validations() {
            const vm = this;
            return {
                form: {
                    region: {
                        required,
                    },
                    city: {
                        required,
                    },
                    street: {
                        required,
                        maxLength: maxLength(78),
                    },
                    contactPerson: {
                        required,
                    },
                    contactNumber: {
                        required,
                        phone: () => {
                            // Check Phone Input Validation Status via
                            // Phone Input valid() listener
                            return vm.validPhone;
                        },
                    },
                    merchantCategory: {
                        required,
                    },
                    shippingBuyout: {
                        required,
                        shouldSelectBuyoutOption: () => {
                            if (!vm.form.shippingBuyout && vm.mrSpeedyShipping) {
                                return vm.form.shippingNonBuyout;
                            }
                            return true;
                        },
                    },
                    shippingNonBuyout: {
                        required,
                        shouldSelectNonBuyoutOption: () => {
                            if (!vm.form.shippingNonBuyout && vm.mrSpeedyShipping) {
                                return vm.form.shippingBuyout;
                            }
                            return true;
                        },
                    },
                    description: {
                        required,
                    },
                    lat: {
                        required,
                    },
                    lng: {
                        required,
                    },
                    barangay: {
                        required,
                        maxLength: maxLength(78),
                    },
                    building: {
                        required: requiredIf(() => {
                            return vm.isRequired;
                        }),
                        maxLength: maxLength(78),
                    },
                    floorNumber: {
                        required: requiredIf(() => {
                            return vm.isRequired;
                        }),
                        maxLength: maxLength(10),
                    },
                    unitNumber: {
                        required: requiredIf(() => {
                            return vm.isRequired;
                        }),
                        maxLength: maxLength(10),
                    },
                    pickUpTimeSlot: {
                        required: requiredIf(() => {
                            return vm.ninjaVanShipping;
                        }),
                    },
                },
            };
        },
    })
], ShippingFormThirdParty);
export default ShippingFormThirdParty;
